class HHPDPUpsell extends HTMLElement {
  constructor() {
    super()

    this.mainGallery = null;
    this.sectionId = this.getAttribute('data-section-id');
    this.swiperSelector = `[data-section-id='${this.sectionId}'] .swiper`;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.mainGallery = new Swiper(this.swiperSelector, {
      spaceBetween: 5,
      slidesPerView: 2,
      breakpoints: {
        990: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      },
    });
  }
}

customElements.define('hh-pdp-upsell', HHPDPUpsell)